export const analysisStep = {
  id: 'analysis',

  buildPrompt(ctx, prior) {
    const processedScores = prior.scoring?.processedScores || [];
    const total = processedScores.reduce((sum, s) => sum + (Number(s.score) || 0), 0);
    const budget = ctx.computed.totalScoreBudget;

    const perDefaultById = prior.qualification?.perDefaultById || new Map();
    const defaultScores = processedScores.filter((s) => String(s.questionId).startsWith('default_'));
    const passedCount = defaultScores.filter((s) => perDefaultById.get(String(s.questionId))?.passed).length;
    const totalDefaults = defaultScores.length;

    const redactName = ctx.computed.redactName || ((t) => t);
    const qualificationLines = defaultScores
      .map((s) => {
        const q = ctx.computed.questionById.get(String(s.questionId));
        const qText = (q?.text || '').replace(/<[^>]*>/g, '').trim() || s.questionId;
        const verdict = perDefaultById.get(String(s.questionId));
        const passLabel = verdict?.passed ? 'BESTANDEN' : 'NICHT BESTANDEN';
        const reason = verdict?.reason ? ` — ${redactName(verdict.reason)}` : '';
        // Redact per fragment, never the whole line — keep the questionId intact.
        return `- [${s.questionId}] ${redactName(qText)}: ${passLabel}${reason}`;
      })
      .join('\n');

    return `Schritt 3 — Gesamtbewertung.

Du hast soeben die Punktevergabe und die Qualifikationsprüfung abgeschlossen.
Punkte gesamt: ${total} / ${budget}.
Formale Pflichtfragen erfüllt: ${passedCount} von ${totalDefaults}.

Qualifikationsverdikte aus Schritt 2:
${qualificationLines || '(keine formalen Pflichtfragen)'}

Schreibe nun EINE zusammenhängende Gesamtbewertung des Bewerbers:
- analysisScore: 0-100 (orientiert an Punkteanteil + Qualifikation, nicht stur prozentual)
- summary: 3-5 Sätze (Deutsch). MUSS zwingend folgendes abdecken, in EINEM zusammenhängenden Fließtext, nicht in zwei getrennten Blöcken:
  1) Formale Eignung: nenne explizit, ob/welche Pflichtfragen nicht bestanden wurden und was das für die Eignung bedeutet (bei vollständigem Bestehen kurz erwähnen, dass die formalen Voraussetzungen erfüllt sind).
  2) Inhaltliche Eignung: die Qualität der Antworten auf die offenen/fachlichen Fragen.
  Beide Aspekte müssen ineinandergreifen, ohne sich zu widersprechen.
- strengths: Liste konkreter Stärken (Deutsch, jeweils 1 Satz, mit Bezug zu einer konkreten Antwort)
- weaknesses: Liste konkreter Schwächen (Deutsch, jeweils 1 Satz)
- areasForDiscussion: Punkte, die im Vorstellungsgespräch geklärt werden sollten (Deutsch, jeweils 1 Satz)

Beziehe Dich auf konkrete Antworten, keine Allgemeinplätze.`;
  },

  schema: {
    type: 'OBJECT',
    properties: {
      analysisScore: { type: 'NUMBER' },
      summary: { type: 'STRING' },
      strengths: { type: 'ARRAY', items: { type: 'STRING' } },
      weaknesses: { type: 'ARRAY', items: { type: 'STRING' } },
      areasForDiscussion: { type: 'ARRAY', items: { type: 'STRING' } }
    },
    // Without `required`, Gemini treats every field as optional and intermittently
    // omits whole keys (observed: `strengths` and `areasForDiscussion` dropped on
    // ~1 in 3 calls). parse() then coerces the missing array to [] and the UI hides
    // the section — so strengths silently vanished. Force all keys to be emitted.
    propertyOrdering: ['analysisScore', 'summary', 'strengths', 'weaknesses', 'areasForDiscussion'],
    required: ['analysisScore', 'summary', 'strengths', 'weaknesses', 'areasForDiscussion']
  },

  parse(json) {
    return {
      analysisScore: Number(json?.analysisScore) || 0,
      summary: json?.summary || '',
      strengths: Array.isArray(json?.strengths) ? json.strengths : [],
      weaknesses: Array.isArray(json?.weaknesses) ? json.weaknesses : [],
      areasForDiscussion: Array.isArray(json?.areasForDiscussion) ? json.areasForDiscussion : []
    };
  }
};
